export default "__VITE_ASSET__c1bd1e22__"